import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel
initMetaPixel('931401796468747');
render(<App data-id="element-310" />, document.getElementById('root'));